module.exports = __webpack_public_path__ + "media/images/smart_phone/icons/list_recomend-efdea6bcd874ed32e1726cf7dd9f6cd4.png";